/* tslint:disable */
/* eslint-disable */
/**
 * Ameta Delivery API
 * This API manages the projects and docuements that are stored in the Ameta Document Delivery. The API used oAuth2 flow for authorization.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GeoJSONLocation,
    GeoJSONLocationFromJSON,
    GeoJSONLocationFromJSONTyped,
    GeoJSONLocationToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProjectDocumentRelation
 */
export interface ProjectDocumentRelation {
    /**
     * 
     * @type {string}
     * @memberof ProjectDocumentRelation
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectDocumentRelation
     */
    sort: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectDocumentRelation
     */
    projectName: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectDocumentRelation
     */
    projectNumber: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectDocumentRelation
     */
    documentName: string;
    /**
     * 
     * @type {number}
     * @memberof ProjectDocumentRelation
     */
    documentSize: number;
    /**
     * 
     * @type {string}
     * @memberof ProjectDocumentRelation
     */
    documentS3Href: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectDocumentRelation
     */
    documentType: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectDocumentRelation
     */
    documentTimeCreated: string;
    /**
     * 
     * @type {GeoJSONLocation}
     * @memberof ProjectDocumentRelation
     */
    documentLocation?: GeoJSONLocation;
    /**
     * 
     * @type {string}
     * @memberof ProjectDocumentRelation
     */
    documentStatus?: string;
}

export function ProjectDocumentRelationFromJSON(json: any): ProjectDocumentRelation {
    return ProjectDocumentRelationFromJSONTyped(json, false);
}

export function ProjectDocumentRelationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectDocumentRelation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'sort': json['sort'],
        'projectName': json['projectName'],
        'projectNumber': json['projectNumber'],
        'documentName': json['documentName'],
        'documentSize': json['documentSize'],
        'documentS3Href': json['documentS3Href'],
        'documentType': json['documentType'],
        'documentTimeCreated': json['documentTimeCreated'],
        'documentLocation': !exists(json, 'documentLocation') ? undefined : GeoJSONLocationFromJSON(json['documentLocation']),
        'documentStatus': !exists(json, 'documentStatus') ? undefined : json['documentStatus'],
    };
}

export function ProjectDocumentRelationToJSON(value?: ProjectDocumentRelation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'sort': value.sort,
        'projectName': value.projectName,
        'projectNumber': value.projectNumber,
        'documentName': value.documentName,
        'documentSize': value.documentSize,
        'documentS3Href': value.documentS3Href,
        'documentType': value.documentType,
        'documentTimeCreated': value.documentTimeCreated,
        'documentLocation': GeoJSONLocationToJSON(value.documentLocation),
        'documentStatus': value.documentStatus,
    };
}


